__turbopack_context__.v({
  "arrowIcon": "CoursePromoBanner-module-scss-module__fHCQUW__arrowIcon",
  "badge": "CoursePromoBanner-module-scss-module__fHCQUW__badge",
  "content": "CoursePromoBanner-module-scss-module__fHCQUW__content",
  "ctaButton": "CoursePromoBanner-module-scss-module__fHCQUW__ctaButton",
  "left": "CoursePromoBanner-module-scss-module__fHCQUW__left",
  "partner": "CoursePromoBanner-module-scss-module__fHCQUW__partner",
  "promoBanner": "CoursePromoBanner-module-scss-module__fHCQUW__promoBanner",
  "right": "CoursePromoBanner-module-scss-module__fHCQUW__right",
  "sparkleIcon": "CoursePromoBanner-module-scss-module__fHCQUW__sparkleIcon",
  "stat": "CoursePromoBanner-module-scss-module__fHCQUW__stat",
  "statDivider": "CoursePromoBanner-module-scss-module__fHCQUW__statDivider",
  "statIcon": "CoursePromoBanner-module-scss-module__fHCQUW__statIcon",
  "statsRow": "CoursePromoBanner-module-scss-module__fHCQUW__statsRow",
  "title": "CoursePromoBanner-module-scss-module__fHCQUW__title",
  "topRow": "CoursePromoBanner-module-scss-module__fHCQUW__topRow",
});
